document.addEventListener("alpine:init", () => {
  Alpine.data("livestreamScheduleSubscribe", () => ({
    open: false,
    loading: false,
    email: "",
    errMsg: "",
    invalidEmailErrMsg: "",
    disclaimerErrMsg: "",
    checked: true,
    isSuccess: false,
    activeBlockId: null,
    scheduledIds: [],
    settings: {},
    storageKey: "",

    init() {
      const sectionId = this.$el.dataset.sectionId || "default";
      this.settings =
        (window.livestreamScheduleSettingJsons &&
          window.livestreamScheduleSettingJsons[sectionId]) ||
        {};
      this.storageKey = `ls-schedule-subscribed-${sectionId}`;
      try {
        const raw = localStorage.getItem(this.storageKey);
        this.scheduledIds = raw ? JSON.parse(raw) : [];
      } catch (e) {
        this.scheduledIds = [];
      }
    },

    isScheduled(blockId) {
      return this.scheduledIds.indexOf(blockId) !== -1;
    },

    openPopup(blockId) {
      if (this.isScheduled(blockId)) return;
      this.activeBlockId = blockId;
      this.email = "";
      this.errMsg = "";
      this.invalidEmailErrMsg = "";
      this.disclaimerErrMsg = "";
      this.isSuccess = false;
      this.checked = true;
      this.open = true;
      document.documentElement.style.overflow = "hidden";
    },

    closePopup() {
      this.open = false;
      this.activeBlockId = null;
      document.documentElement.style.overflow = "";
    },

    markScheduled(blockId) {
      if (!blockId || this.isScheduled(blockId)) return;
      this.scheduledIds = [...this.scheduledIds, blockId];
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(this.scheduledIds));
      } catch (e) {
        // ignore storage failures
      }
    },

    async submitResult() {
      this.errMsg = "";
      this.invalidEmailErrMsg = "";
      this.disclaimerErrMsg = "";

      if (this.email === "") {
        this.errMsg = this.settings.empty_email_error_text || "Please enter your email address.";
        return;
      }
      if (typeof validateEmail !== "function" || !validateEmail(this.email)) {
        this.invalidEmailErrMsg = this.settings.email_error_text || "Email: invalid format!";
        return;
      }
      if (!this.checked) {
        this.disclaimerErrMsg =
          this.settings.disclaimer_error_text || "Please tick agreement boxes to proceed.";
        return;
      }

      const fieldsArray = createFieldsArray(this.settings);
      const contactListId = getContactListId(this.settings);
      const { apiUrl, acceptedLanguage, apiKey, xAppid } = theme.emailSubscription;

      const subscribeInfoCookie =
        typeof window.getCookieForEmarsys === "function"
          ? window.getCookieForEmarsys("subscribe_info")
          : null;
      let eventTracking = null;
      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie);
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts;
        } catch (error) {
          console.warn("Failed to parse subscribe_info cookie:", error);
        }
      }

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };

      this.loading = true;
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            apiKey: apiKey,
            traceId: typeof traceId !== "undefined" ? traceId : "",
            "X-appid": xAppid,
            "Accepted-Language": acceptedLanguage,
          },
          body: JSON.stringify(apiBody),
        });
        const data = await response.json();
        if (data.message === "Success") {
          this.isSuccess = true;
          this.markScheduled(this.activeBlockId);
          setTimeout(() => {
            this.closePopup();
          }, 1200);
        } else {
          this.errMsg = "Oops... Something went wrong, please refresh and try again.";
        }
      } catch (error) {
        this.errMsg = "Oops... Something went wrong, please refresh and try again.";
      } finally {
        this.loading = false;
      }
    },
  }));
});
